import { render, staticRenderFns } from "./RecipientsStep.vue?vue&type=template&id=faba990a&scoped=true&"
import script from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecipientsStep.vue?vue&type=style&index=0&id=faba990a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faba990a",
  null
  
)

export default component.exports